export enum ConsolidationStatus {
    Started = "Started",
    Failed = "Failed",
    ActionRequired = "Action Required",
    Completed = "Completed"
}